import React from "react";
import "./Header.scss";

import { NavLink } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import $ from "jquery";


class Header extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
      userName: sessionStorage.getItem("displayName"),
      displayName: sessionStorage.getItem("displayName"),
			roleList : "",
			userDetails : [],
			blocking : false,
			RFQuotation:false,
			approval:false,	
			NcrmRequest:false,
			Authorization:false,
			FGFreight:false,
			CarrierMaster: false,
			Qualification: false,
			isBB : false,
			isCarrier : false,
			isApprover : false,
			isGB : false,
			isApproverMatrixRole : false,
			ncrmEnvLink : "",
			isFGDockUrl: false,
      lastUrl: ""
		}
	}

async	componentDidMount() {
  
  
  if (window.location.href.includes("FgCrossDock") || window.location.href.includes("FgCrossDockMassUpload")) {
    this.setState({isFGDockUrl: true});
  } else {
    this.setState({isFGDockUrl: false});
  }

    this.setState({
      blocking: !this.state.blocking,
    });
    var absUrl = localStorage.getItem("xpath");
    localStorage.removeItem("xpath");
    if (absUrl != null) {
      if (absUrl.length > 0) window.location = absUrl;
    }
    
    let userProfile = sessionStorage.getItem("profile");
    
    if (userProfile !== null) {
      let userProfileData = JSON.parse(userProfile).ROLE_LIST;
      let userFirstName =
        JSON.parse(userProfile).FIRST_NAME +
        " " +
        JSON.parse(userProfile).LAST_NAME;

      this.setState({
        displayName: sessionStorage.getItem("displayName"),
      });
    
      this.state.userName = userFirstName;
      this.state.roleList = userProfileData;
      if (this.state.roleList["BB"] == "True") {
        this.state.isBB = true;
      } else if (this.state.roleList.CARRIER == "True") {
        this.state.isCarrier = true;
      } else if (this.state.roleList.APPROVER == "True") {
        this.state.isApprover = true;
      } else if (this.state.roleList.CW == "True") {
        this.state.isGB = true;
      }

      if (
        this.state.roleList.APPROVER === "True" &&
        this.state.roleList.MDAPPROVERMATRIX === "True"
      ) {
        this.state.isApproverMatrixRole = true;
      }
      if (this.state.roleList.MDAPPROVERMATRIX === "True") {
        this.setState({ CarrierMaster: true });
      }

      if (this.state.roleList.MDPREQUAL === "True") {
        this.setState({ Qualification: true });
      }

      if (this.state.roleList.MDADMIN === "True") {
        this.setState({ CarrierMaster: true });
      }

      this.setState({ userDetails: userProfile, blocking: false });
    }
  }

  toTitleCase = function (str) {
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
  };

  closeMenu() {
    $("#mySidepanel").toggleClass("active");
    $("#custom-move-Menu").removeClass("custom-move");
    $("#sidebarCollapse").removeClass("active");
  }

  ncrmLink() {
    let ncrmUrl = window.location.href.toLowerCase().includes("localhost")
      ? "https://ncrmdev.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://ncrmdev.apps1-fm-int.icloud.intel.com/")
      ? "https://ncrmdev.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://tmsconsint.apps1-fm-int.icloud.intel.com/")
      ? "https://tmsconsint.apps1-fm-int.icloud.intel.com/"
      : window.location.href
          .toLowerCase()
          .includes("https://transportationcons.intel.com")
      ? "https://transportationcons.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://transportation.intel.com")
      ? "https://transportation.intel.com"
      : "";
    this.setState({ ncrmEnvLink: ncrmUrl });
  }

  render() {
    return (
          <>
             <nav id="mySidepanel" className="sidepanel">
              {!this.state.isFGDockUrl && (
                <ul className="list-unstyled components">
                  <li>
                    <NavLink onClick={this.closeMenu} to="/NCRMHome">
                      {"NCRM Request"}
                    </NavLink>
                  </li>
                  <li>
                    {this.state.isBB && (
                      <NavLink onClick={this.closeMenu} to="/ncrmauthorization">
                        {"Authorizations"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.isBB && (
                      <NavLink onClick={this.closeMenu} to="/FGSearch">
                        {"Staged FG Freight Orders"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.isApprover && (
                      <NavLink onClick={this.closeMenu} to="/Approver">
                        {"Approval"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.isApprover && (
                      <NavLink onClick={this.closeMenu} to="/AssignDelegate">
                        {"Assign Delegate"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.CarrierMaster && (
                      <NavLink onClick={this.closeMenu} to="/carrier">
                        {"Carrier Master"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.Qualification && (
                      <NavLink onClick={this.closeMenu} to="/prequal">
                        {"Qualification"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.isApproverMatrixRole && (
                      <NavLink onClick={this.closeMenu} to="/ApprovalMatrix">
                        {"Approval Matrix"}
                      </NavLink>
                    )}
                  </li>
                  <li>
                    {this.state.isCarrier && (
                      <NavLink onClick={this.closeMenu} to="/RFQ">
                        {"Request For Quotation"}
                      </NavLink>
                    )}
                  </li>
                </ul>
              )}

              {this.state.isFGDockUrl && (
                <ul className="list-unstyled components">
                  <li>
                    {
                      <NavLink onClick={this.closeMenu} to="/FgCrossDock">
                        {"XD ETA update"}
                      </NavLink>
                    }
                  </li>
                  <li>
                    {
                      <NavLink onClick={this.closeMenu} to="/FgCrossDockMassUpload">
                        {"XD ETA upload"}
                      </NavLink>
                    }
                  </li>
                </ul>
              )}
            </nav>

           
          </>
    );
  }
}

$(document).ready(function () {
  $("#mySidepanel ul li").on("click", function () {
    if ($(this).hasClass("active")) {
      $("#leftpanel").show();
      $("#leftpanel").css("position", "absolute");
      $("#leftpanel").css("top", "-32px");
      $("#rightpanel").hide();
      $("button#sidebarCollapse").css("padding", "0px");
      $("div.content-view").css("padding-left", "13px");
      $("content-move").css("margin-top", "10px");
      $("#content").css("margin-top", "0px !important")
      $("#mySidepanel").css("top", "83px !important")
    } else {
      $("#leftpanel").hide();
      $("#rightpanel").show();
      $("#mySidepanel").css("top", "83px !important")
      $("#content").css("margin-top", "0px !important")

      $("#rightpanel").css("position", "absolute");
      $("#rightpanel").css("right", "0px");
      $("#rightpanel").css("top", "10px");
      $("button#sidebarCollapse").css("top", "17px !important");
      $("button#sidebarCollapse").css("padding", "13px");
      $("#sidebarCollapse").css("margin-top", "86px !important");
      $("div.content-view").css("padding-left", "13px");
    }
  });

  $("button#sidebarCollapse").css("padding", "0px");
  $("#mySidepanel").toggleClass("active");
  $("#mySidepanel").css("top", "83px");
  $("#custom-move-Menu").addClass("custom-move");
  $("#sidebarCollapse").addClass("active");
  $("#rightpanel").hide();
  $("#leftpanel").show();
  $("#leftpanel").css("top", "2.8% !important");
  $("#sidebarCollapse").on("click", function () {
    $("#mySidepanel").toggleClass("active");
    $(this).toggleClass("active");

    if ($(this).hasClass("active")) {
      $("button#sidebarCollapse").css("padding", "0px");
      $("div.content-view").css("padding-left", "11px");
      $("#rightpanel").hide();
      $("#leftpanel").show();
      $("#custom-move-Menu").addClass("custom-move");
    } else {
      $("div.content-view").css("padding-left", "18px");
      $("button#sidebarCollapse").css("padding", "13px");
      $("#leftpanel").hide();
      $("#rightpanel").show();
      $("#custom-move-Menu").removeClass("custom-move");
    }
  });
});

export default Header;